import { t } from "i18next";
import { Athlete, AthleteMeasurement } from "../../interfaces/athlete";
import moment from 'moment';
import ReactECharts from 'echarts-for-react';
import chartsIcon from "../../assets/images/charts.svg";

interface AthleteBMIChartProps {
    athlete: Athlete;
}

export function AthleteBMIChart(props: AthleteBMIChartProps) {
    const options = {
        xAxis: {
            type: 'category',
            data: props.athlete.measurement.map((m: AthleteMeasurement) => {
                return moment(m.measurement_date).format('DD/MM');
            })
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                formatter: '{value} kg/m2'
            }
        },
        series: [
            {
                data: props.athlete.measurement.map((m: AthleteMeasurement) => {
                    return m.bmi;
                }),
                type: 'line',
                smooth: true,
                color: 'red',
                label: {
                    show: true,
                    position: 'top',
                    formatter: '{c} kg/m2'
                }
            }
        ]
    }

    return (
        <div className="athlete-weight-chart-container chart-box">
            <h3 className="chart-title">
                <img src={ chartsIcon } alt={ t("Body Mass Index")} />
                { t("Body Mass Index") }
            </h3>
            <div className="chart-content">
                <ReactECharts option={ options } />
            </div>
        </div>
    );
}